import React from 'react';

export const SvgGallery = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="25"
      height="19"
      viewBox="0 0 25 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.25 0.5H2.75C1.50734 0.5 0.5 1.50734 0.5 2.75V16.25C0.5 17.4927 1.50734 18.5 2.75 18.5H22.25C23.4927 18.5 24.5 17.4927 24.5 16.25V2.75C24.5 1.50734 23.4927 0.5 22.25 0.5ZM21.9688 16.25H3.03125C2.95666 16.25 2.88512 16.2204 2.83238 16.1676C2.77963 16.1149 2.75 16.0433 2.75 15.9688V3.03125C2.75 2.95666 2.77963 2.88512 2.83238 2.83238C2.88512 2.77963 2.95666 2.75 3.03125 2.75H21.9688C22.0433 2.75 22.1149 2.77963 22.1676 2.83238C22.2204 2.88512 22.25 2.95666 22.25 3.03125V15.9688C22.25 16.0433 22.2204 16.1149 22.1676 16.1676C22.1149 16.2204 22.0433 16.25 21.9688 16.25ZM6.5 4.625C5.46448 4.625 4.625 5.46448 4.625 6.5C4.625 7.53552 5.46448 8.375 6.5 8.375C7.53552 8.375 8.375 7.53552 8.375 6.5C8.375 5.46448 7.53552 4.625 6.5 4.625ZM5 14H20V10.25L15.8977 6.14773C15.6781 5.92808 15.3219 5.92808 15.1022 6.14773L9.5 11.75L7.64773 9.89773C7.42808 9.67808 7.07192 9.67808 6.85222 9.89773L5 11.75V14Z"
        fill="currentColor"
      />
    </svg>
  );
};
